import { FiInfo, FiClock } from "react-icons/fi";

interface InstructionsInfoBoxProps {
	deadline?: string | null;
	rfxLeadName?: string;
}

const formatDeadline = (dateStr: string | null | undefined): string => {
	if (!dateStr) {
		return "No deadline set";
	}
	const date = new Date(dateStr);
	return date.toLocaleDateString("en-AU", {
		day: "2-digit",
		month: "short",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	});
};

export const InstructionsInfoBox: React.FC<InstructionsInfoBoxProps> = ({
	deadline,
	rfxLeadName,
}) => {
	return (
		<div
			className="rounded-lg border border-[#0031DD]/20 bg-[#f5f7ff] px-4 py-3"
			data-testid="instructions-info-box"
		>
			<div className="flex items-start gap-2.5 mb-3">
				<FiInfo size={16} className="mt-0.5 shrink-0 text-[#0031DD]" aria-hidden="true" />
				<p className="text-sm font-medium text-gray-900">
					What you need to do
				</p>
			</div>
			<ul className="space-y-2 pl-6 text-sm text-gray-600">
				<li className="flex items-start gap-2">
					<span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#0031DD]" aria-hidden="true" />
					<span>
						Score each supplier against the evaluation criteria. Use the scoring
						guide for reference on how to assign scores.
					</span>
				</li>
				<li className="flex items-start gap-2">
					<span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#0031DD]" aria-hidden="true" />
					<span>
						Add comments to explain your scoring rationale. Comments are visible
						to the RFx Lead.
					</span>
				</li>
				<li className="flex items-start gap-2">
					<span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#0031DD]" aria-hidden="true" />
					<span>
						Your scores are saved automatically as you work. Submit when you have
						finished scoring all suppliers.
					</span>
				</li>
				<li className="flex items-start gap-2">
					<span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#0031DD]" aria-hidden="true" />
					<span>
						Once submitted, scores are <strong>final</strong> and cannot be modified.
					</span>
				</li>
			</ul>

			{deadline && (
				<div className="mt-3 flex flex-wrap items-center gap-3 border-t border-[#0031DD]/10 pt-3">
					<span className="inline-flex items-center gap-1.5 text-xs text-gray-600">
						<FiClock size={12} className="text-gray-400" aria-hidden="true" />
						Deadline: {formatDeadline(deadline)}
					</span>
				</div>
			)}
		</div>
	);
};
